// Fit-Color cross-dependency
(function() {
  'use strict';
  
  var fitColorMap = null;
  var updateTimeout = null;
  var isProcessing = false;
  var isUpdatingVariant = false;
  
  function buildFitColorMap(callback) {
    if (fitColorMap) {
      if (callback) callback();
      return;
    }
    
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    
    var productHandle = productInfo.dataset.productHandle;
    if (!productHandle) return;
    
    fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
      .then(function(response) { return response.json(); })
      .then(function(product) {
        fitColorMap = {};
        product.variants.forEach(function(variant) {
          if (!variant.available) return;
          var color = variant.options[0];
          var fit = variant.options[1];
          if (!fitColorMap[fit]) fitColorMap[fit] = [];
          if (fitColorMap[fit].indexOf(color) === -1) fitColorMap[fit].push(color);
        });
        if (callback) callback();
      })
      .catch(function() {
        if (callback) callback();
      });
  }
  
  function updateColors() {
    if (isProcessing || !fitColorMap) {
      if (!fitColorMap) {
        buildFitColorMap(updateColors);
      }
      return;
    }
    
    var fitWrapper = document.querySelector('[data-option-position="2"]');
    if (!fitWrapper) return;
    
    var selectedFit = fitWrapper.querySelector('.swatch-input__input:checked, input[type="radio"]:checked');
    if (!selectedFit) return;
    
    var availableColors = fitColorMap[selectedFit.value] || [];
    var colorWrapper = document.querySelector('[data-option-position="1"]');
    if (!colorWrapper) return;
    
    isProcessing = true;
    var swatches = colorWrapper.querySelectorAll('.swatch__button');
    
    for (var i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      var input = swatch.querySelector('.swatch-input__input');
      if (!input) continue;
      
      var isAvailable = availableColors.indexOf(input.value) !== -1;
      swatch.classList.toggle('fit-unavailable', !isAvailable);
      input.disabled = false;
    }
    
    isProcessing = false;
  }
  
  function scheduleUpdate() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updateColors, 30);
  }
  
  function forceUpdate() {
    requestAnimationFrame(function() {
      setTimeout(updateColors, 50);
    });
  }
  
  function rebuild() {
    fitColorMap = null;
    buildFitColorMap(function() {
      forceUpdate();
    });
  }
  
  function getVariantTitle(colorValue) {
    var fitWrapper = document.querySelector('[data-option-position="2"]');
    if (!fitWrapper) return colorValue;
    
    var selectedFit = fitWrapper.querySelector('.swatch-input__input:checked, input[type="radio"]:checked');
    if (!selectedFit) return colorValue;
    
    return colorValue + ' / ' + selectedFit.value;
  }
  
  function updateNotificationForm(colorValue) {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    
    var variantTitle = getVariantTitle(colorValue);
    
    var notificationForm = document.querySelector('.product__notification');
    if (!notificationForm) return;
    
    var variantTitleEl = notificationForm.querySelector('[data-variant-title]');
    if (variantTitleEl) {
      variantTitleEl.textContent = variantTitle;
    }
    
    var hiddenInput = notificationForm.querySelector('[data-notification-product]');
    if (hiddenInput) {
      var productTitle = document.querySelector('.product__title')?.textContent?.trim() || '';
      hiddenInput.value = productTitle + ' - ' + variantTitle;
    }
    
    var form = notificationForm.querySelector('form');
    if (form) {
      var colorWrapper = document.querySelector('[data-option-position="1"]');
      var selectedInput = colorWrapper ? colorWrapper.querySelector('.swatch-input__input:checked') : null;
      var variantId = selectedInput ? selectedInput.getAttribute('data-option-value-id') : null;
      
      if (variantId) {
        var sectionId = productInfo.dataset.section || productInfo.dataset.sectionId || 'main';
        form.setAttribute('data-variant-id', variantId);
        form.id = 'NotificationForm--' + sectionId + '--' + variantId;
      }
    }
  }
  
  function handleColorClick(input, isUnavailable) {
    if (isUpdatingVariant) return;
    if (!isUnavailable) return;
    
    isUpdatingVariant = true;
    
    var colorValue = input.value;
    var allColorInputs = document.querySelectorAll('[data-option-position="1"] .swatch-input__input');
    
    allColorInputs.forEach(function(otherInput) {
      if (otherInput !== input) {
        otherInput.checked = false;
      }
    });
    
    input.checked = true;
    
    var changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);
    
    setTimeout(function() {
      updateNotificationForm(colorValue);
      isUpdatingVariant = false;
    }, 100);
  }
  
  function init() {
    buildFitColorMap(function() {
      setTimeout(updateColors, 100);
    });
    
    document.addEventListener('variant:change', forceUpdate);
    
    document.addEventListener('change', function(e) {
      if (e.target.closest && e.target.closest('[data-option-position="2"]')) {
        scheduleUpdate();
      }
    });
    
    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('.swatch__button');
      if (!swatch) return;
      
      var input = swatch.querySelector('.swatch-input__input');
      if (!input) return;
      if (!input.closest || !input.closest('[data-option-position="1"]')) return;
      
      handleColorClick(input, swatch.classList.contains('fit-unavailable'));
    });
    
    document.addEventListener('click', function(e) {
      var label = e.target.closest('label');
      if (!label) return;
      
      var input = document.getElementById(label.getAttribute('for'));
      if (!input) return;
      if (!input.closest || !input.closest('[data-option-position="1"]')) return;
      
      var swatch = input.closest('.swatch__button');
      if (!swatch) return;
      
      handleColorClick(input, swatch.classList.contains('fit-unavailable'));
    });
    
    document.addEventListener('theme:product-info:loaded', function() {
      setTimeout(function() {
        fitColorMap = null;
        buildFitColorMap(function() {
          forceUpdate();
        });
      }, 100);
    });
    
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target.querySelector('product-info')) {
        setTimeout(function() {
          fitColorMap = null;
          buildFitColorMap(function() {
            forceUpdate();
          });
        }, 200);
      }
    });
    
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1 && (node.matches('variant-selects') || node.querySelector('variant-selects'))) {
              setTimeout(updateColors, 100);
              break;
            }
          }
        }
      }
    });
    
    function startObserver() {
      var productForm = document.querySelector('.product__form__holder');
      if (productForm) {
        observer.observe(productForm, {
          childList: true,
          subtree: true
        });
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();